__turbopack_context__.v({
  "desktopMenu": "Menu-module___MGL3q__desktopMenu",
  "desktopMenuItem": "Menu-module___MGL3q__desktopMenuItem",
  "menuContainer": "Menu-module___MGL3q__menuContainer",
  "menuItem": "Menu-module___MGL3q__menuItem",
  "menuItemLabel": "Menu-module___MGL3q__menuItemLabel",
  "menuItems": "Menu-module___MGL3q__menuItems",
  "mobileProfileIcon": "Menu-module___MGL3q__mobileProfileIcon",
  "profileButton": "Menu-module___MGL3q__profileButton",
  "profileIcon": "Menu-module___MGL3q__profileIcon",
  "profileMenuButton": "Menu-module___MGL3q__profileMenuButton",
  "whitespace": "Menu-module___MGL3q__whitespace",
});
